/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Conference', 'model/DataResponse', 'model/ErrorResponse', 'model/Lecturer', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Presentation', 'model/Question', 'model/Sponsor', 'model/SuccessResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/Conference'), require('../model/DataResponse'), require('../model/ErrorResponse'), require('../model/Lecturer'), require('../model/Params'), require('../model/Params1'), require('../model/Params2'), require('../model/Params3'), require('../model/Presentation'), require('../model/Question'), require('../model/Sponsor'), require('../model/SuccessResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.DefaultApi = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Conference, root.ConferenceBackend.DataResponse, root.ConferenceBackend.ErrorResponse, root.ConferenceBackend.Lecturer, root.ConferenceBackend.Params, root.ConferenceBackend.Params1, root.ConferenceBackend.Params2, root.ConferenceBackend.Params3, root.ConferenceBackend.Presentation, root.ConferenceBackend.Question, root.ConferenceBackend.Sponsor, root.ConferenceBackend.SuccessResponse);
  }
}(this, function(ApiClient, Conference, DataResponse, ErrorResponse, Lecturer, Params, Params1, Params2, Params3, Presentation, Question, Sponsor, SuccessResponse) {
  'use strict';

  /**
   * Default service.
   * @module api/DefaultApi
   * @version 0.0.1
   */

  /**
   * Constructs a new DefaultApi. 
   * @alias module:api/DefaultApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the deleteQuestion operation.
     * @callback module:api/DefaultApi~deleteQuestionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a question
     * @param {String} questionId 
     * @param {module:api/DefaultApi~deleteQuestionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    this.deleteQuestion = function(questionId, callback) {
      var postBody = null;

      // verify the required parameter 'questionId' is set
      if (questionId == undefined || questionId == null) {
        throw new Error("Missing the required parameter 'questionId' when calling deleteQuestion");
      }


      var pathParams = {
      };
      var queryParams = {
        'questionId': questionId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SuccessResponse;

      return this.apiClient.callApi(
        '/presentation/survey/question', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getConferenceInformation operation.
     * @callback module:api/DefaultApi~getConferenceInformationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Conference} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get general info about the conference
     * @param {module:api/DefaultApi~getConferenceInformationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Conference}
     */
    this.getConferenceInformation = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Conference;

      return this.apiClient.callApi(
        '/conference', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getCurrentQuestion operation.
     * @callback module:api/DefaultApi~getCurrentQuestionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Question} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the current question
     * @param {module:api/DefaultApi~getCurrentQuestionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Question}
     */
    this.getCurrentQuestion = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Question;

      return this.apiClient.callApi(
        '/presentation/survey/current', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getLecturers operation.
     * @callback module:api/DefaultApi~getLecturersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Lecturer>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns lecturer list
     * @param {module:api/DefaultApi~getLecturersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Lecturer>}
     */
    this.getLecturers = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [Lecturer];

      return this.apiClient.callApi(
        '/lecturers', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPresentations operation.
     * @callback module:api/DefaultApi~getPresentationsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Presentation>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns presentation list
     * @param {module:api/DefaultApi~getPresentationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Presentation>}
     */
    this.getPresentations = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [Presentation];

      return this.apiClient.callApi(
        '/presentations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRatings operation.
     * @callback module:api/DefaultApi~getRatingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all ratings
     * @param {module:api/DefaultApi~getRatingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataResponse}
     */
    this.getRatings = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = DataResponse;

      return this.apiClient.callApi(
        '/presentation/rating', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getSponsors operation.
     * @callback module:api/DefaultApi~getSponsorsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Sponsor>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns sponsors list
     * @param {module:api/DefaultApi~getSponsorsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Sponsor>}
     */
    this.getSponsors = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [Sponsor];

      return this.apiClient.callApi(
        '/sponsors', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getSurveyResult operation.
     * @callback module:api/DefaultApi~getSurveyResultCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Question>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get answers for presentation
     * @param {String} presentationId 
     * @param {module:api/DefaultApi~getSurveyResultCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Question>}
     */
    this.getSurveyResult = function(presentationId, callback) {
      var postBody = null;

      // verify the required parameter 'presentationId' is set
      if (presentationId == undefined || presentationId == null) {
        throw new Error("Missing the required parameter 'presentationId' when calling getSurveyResult");
      }


      var pathParams = {
      };
      var queryParams = {
        'presentationId': presentationId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [Question];

      return this.apiClient.callApi(
        '/presentation/survey', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postAnswer operation.
     * @callback module:api/DefaultApi~postAnswerCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Posts an answer
     * @param {module:model/Params1} params 
     * @param {module:api/DefaultApi~postAnswerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    this.postAnswer = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params == undefined || params == null) {
        throw new Error("Missing the required parameter 'params' when calling postAnswer");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SuccessResponse;

      return this.apiClient.callApi(
        '/presentation/survey', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postCurrentQuestion operation.
     * @callback module:api/DefaultApi~postCurrentQuestionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set the current question
     * @param {module:model/Params2} params 
     * @param {module:api/DefaultApi~postCurrentQuestionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    this.postCurrentQuestion = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params == undefined || params == null) {
        throw new Error("Missing the required parameter 'params' when calling postCurrentQuestion");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SuccessResponse;

      return this.apiClient.callApi(
        '/presentation/survey/current', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postQuestion operation.
     * @callback module:api/DefaultApi~postQuestionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Posts a question or a question edit
     * @param {module:model/Params3} params 
     * @param {module:api/DefaultApi~postQuestionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    this.postQuestion = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params == undefined || params == null) {
        throw new Error("Missing the required parameter 'params' when calling postQuestion");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SuccessResponse;

      return this.apiClient.callApi(
        '/presentation/survey/question', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postRating operation.
     * @callback module:api/DefaultApi~postRatingCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Posts a rating
     * @param {module:model/Params} params 
     * @param {module:api/DefaultApi~postRatingCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    this.postRating = function(params, callback) {
      var postBody = params;

      // verify the required parameter 'params' is set
      if (params == undefined || params == null) {
        throw new Error("Missing the required parameter 'params' when calling postRating");
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SuccessResponse;

      return this.apiClient.callApi(
        '/presentation/rating', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));




// WEBPACK FOOTER //
// ./generated/src/api/DefaultApi.js